var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreyBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 .532C18.89.16 17.67 0 16.5 0c-1.95 0-4.05.426-5.5 1.597C9.55.426 7.45 0 5.5 0 3.55 0 1.45.426 0 1.597v15.6c0 .266.25.532.5.532.1 0 .15-.053.25-.053 1.35-.692 3.3-1.171 4.75-1.171 1.95 0 4.05.426 5.5 1.597 1.35-.905 3.8-1.597 5.5-1.597 1.65 0 3.35.32 4.75 1.118.1.053.15.053.25.053.25 0 .5-.266.5-.532V1.596c-.6-.479-1.25-.798-2-1.065Zm0 14.375c-1.1-.372-2.3-.532-3.5-.532-1.7 0-4.15.692-5.5 1.597V3.727c1.35-.905 3.8-1.597 5.5-1.597 1.2 0 2.4.16 3.5.532v12.245Z",
    fill: "#A6ABB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.389c.88 0 1.73.096 2.5.277V5.047c-.79-.16-1.64-.255-2.5-.255-1.7 0-3.24.308-4.5.883v1.768c1.13-.682 2.7-1.054 4.5-1.054ZM12 8.508v1.767c1.13-.681 2.7-1.054 4.5-1.054.88 0 1.73.096 2.5.277V7.88c-.79-.16-1.64-.256-2.5-.256-1.7 0-3.24.32-4.5.884ZM16.5 10.467c-1.7 0-3.24.309-4.5.884v1.767c1.13-.681 2.7-1.054 4.5-1.054.88 0 1.73.096 2.5.277v-1.619c-.79-.17-1.64-.255-2.5-.255Z",
    fill: "#A6ABB9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyBook);
export default __webpack_public_path__ + "static/media/GreyBook.400d5214daac650c59df6ee28b1b12c2.svg";
export { ForwardRef as ReactComponent };